import "@firebase/firestore";
import * as firebase from "firebase";
import "firebase/auth";
import * as moment from "moment";
import { TIMEOUT } from "src/global";
import firebaseApp from "../config/fbConfig";
import fs from "../config/fbConfig";
import { IAuthService, IProfile } from "./interfaces";

export default class FirebaseAuthService implements IAuthService {
  private fbApp: firebase.app.App;
  private firestoreDb: firebase.firestore.Firestore;
  private user: any;

  public constructor() {
    this.fbApp = firebaseApp.firebaseApp;
    this.firestoreDb = fs.fs;
  }

  public App(): firebase.app.App {
    return this.fbApp;
  }

  public login(email: string, password: string): Promise<firebase.auth.UserCredential> {
    return this.fbApp.auth().signInWithEmailAndPassword(email, password);
  }

  public register(email: string, password: string): Promise<firebase.auth.UserCredential> {
    return this.fbApp.auth().createUserWithEmailAndPassword(email, password);
  }

  public registerUser(user: firebase.User, displayName: string, photoURL: string): Promise<void> {
    return user.updateProfile({ displayName, photoURL });
  }

  public setUser(user: any, firstName?: string, lastName?: string): Promise<any> {
    this.user = user;
    setTimeout(() => {
      sessionStorage.setItem(
        "loginTimeStamp",
        moment()
          .valueOf()
          .toString()
      );
    }, TIMEOUT);
    if (firstName && lastName) {
      const currentUser = this.fbApp.auth().currentUser;
      if (currentUser) {
        const displayName = `${firstName} ${lastName}`;
        this.user = currentUser;
        return this.firestoreDb
          .collection("users")
          .doc(this.user.uid)
          .set({
            displayName,
            email: this.user.email,
            phoneNumber: this.user.phoneNumber,
            photoURL: this.user.photoURL,
            uid: this.user.uid,
            firstName,
            lastName,
            initials: `${firstName[0]}${lastName[0]}`,
          })
          .then(() => {
            currentUser.updateProfile({
              displayName,
              photoURL: null,
            });
          });
      }
    }
    return new Promise<void>(resolve => {
      resolve(undefined);
    });
  }

  public authenticate(): void {
    this.fbApp.auth().onAuthStateChanged((user: firebase.User) => {
      if (user) {
        this.user = user;
      } else {
        this.user = null;
      }
    });
  }
  public isAuthenticated(): boolean {
    const loginTimeStamp = sessionStorage.getItem("loginTimeStamp");
    if (loginTimeStamp === "") {
      return false;
    } else if (loginTimeStamp !== "") {
      const loginDate = moment(Number(loginTimeStamp));
      const duration = moment.duration(moment().diff(loginDate));
      if (duration.days() > 1) {
        return false;
      }
    }
    return this.user !== null && this.user !== undefined;
  }
  public getAccessToken(): string {
    if (this.isAuthenticated() && this.user) {
      this.user
        .getIdTokenResult()
        .then((idTokenResult: firebase.auth.IdTokenResult) => {
          return idTokenResult.token;
        })
        .catch(() => {
          return "";
        });
    }
    return "";
  }
  public getUserProfileId(): string {
    if (this.isAuthenticated() && this.user) {
      return this.user.uid;
    }
    return "";
  }
  public getProfile(): IProfile {
    if (this.isAuthenticated() && this.user) {
      if (this.user.displayName) {
        const [firstName, lastName] = this.user.displayName.split(" ");
        let initials = "";
        if (firstName && lastName) {
          initials = firstName[0] + lastName[0];
        }
        return {
          displayName: this.user.displayName,
          email: this.user.email,
          phoneNumber: this.user.phoneNumber,
          photoURL: this.user.photoURL,
          uid: this.user.uid,
          initials,
        };
      }
      return {
        displayName: this.user.displayName,
        email: this.user.email,
        phoneNumber: this.user.phoneNumber,
        photoURL: this.user.photoURL,
        uid: this.user.uid,
        initials: "",
      };
    }
    return {
      displayName: null,
      email: null,
      phoneNumber: null,
      photoURL: null,
      uid: "",
      initials: null,
    };
  }
  public logout(history: any): Promise<any> {
    sessionStorage.removeItem("loginTimeStamp");
    return this.fbApp
      .auth()
      .signOut()
      .then(() => {
        this.user = null;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/firebaseAuthService.tsx